import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getReporting } from '@/api/api';
import type { FanguardApiContractsReportDefinitionsResponseModel } from 'src/api/generated';

export const REPORT_URI = 'report';

export const reportQueries = createQueryKeys(REPORT_URI, {
  all: null,
  definitions: {
    queryKey: ['definitions'] as const,
    queryFn: async () => {
      const response = await getReporting<FanguardApiContractsReportDefinitionsResponseModel[]>({
        uri: `${REPORT_URI}/definitions`,
      });
      return response.data;
    },
  },
});
